<template>
    <div class="lp-wave-content">
      <div class="lp-wave-login ly-row ly-center-center">
        <div class="ly-col ly-center-center form-container" v-load-fade-in="{ delay: 1000, timeBetween: 500 }">
          <transition name="fade">
            <div v-show="true" class="card lp-load-fadein">
              <OTPForm />
            </div>
          </transition>
        </div>
      </div>
    </div>
</template>

<script setup lang="ts">
import OTPForm from './components/OTPForm.vue'
</script>

<style scoped>
.form-container {
  background: transparent !important;
  /* padding-bottom: 120px !important; */
}

.form-container .card {
  width: 550px;
  box-shadow: none !important;
  /* background: transparent !important; */
  background: rgba(255,255,255,.5) !important;
}
</style>
